import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Tag } from "@/types/prompt";
import { RootState } from "@/store";

type TagState = {
  tagList: Tag[];
};

const initialState: TagState = {
  tagList: [],
};

type AddTag = {
  index: number;
  tag: Tag;
};

export const negTagSlice = createSlice({
  name: "negtags",
  initialState,
  reducers: {
    tagAdd: (state, action: PayloadAction<Tag>) => {
      state.tagList.push(action.payload);
    },
    tagAddIndex: (state, action: PayloadAction<AddTag>) => {
      const { index, tag } = action.payload;
      state.tagList.splice(index + 1, 0, tag);
    },
    tagsAdd: (state, action: PayloadAction<Tag[]>) => {
      state.tagList = [];
      state.tagList = [...state.tagList, ...action.payload];
    },
    tagUpdate: (state, action: PayloadAction<Tag>) => {
      const { id } = action.payload;
      const index = state.tagList.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.tagList[index] = { ...state.tagList[index], ...action.payload };
      }
    },
    tagRemove: (state, action: PayloadAction<number>) => {
      const tag = state.tagList[action.payload];
      state.tagList = state.tagList.filter((item) => item.id !== tag.id);
    },
    negTagClear:(state)=>{
      state.tagList = []
    }
  },
});

export const { tagAdd, tagsAdd, tagUpdate, tagRemove, tagAddIndex,negTagClear } = negTagSlice.actions;
export const selectTagList = (state: RootState) => state.negtags.tagList;
export default negTagSlice.reducer;
